import { render } from "./ProjectDescriptionText.vue?vue&type=template&id=3e4a5f3f"
import script from "./ProjectDescriptionText.vue?vue&type=script&lang=js"
export * from "./ProjectDescriptionText.vue?vue&type=script&lang=js"

import "./ProjectDescriptionText.vue?vue&type=style&index=0&id=3e4a5f3f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__